export default {
    title: 'Suscríbete a nuestro blog',
    subtitle:
        'Te avisaremos cuando publiquemos nuevos artículos y consejos que te ayudarán a mejorar tu educación financiera y te permitirán ser un gran inversor. Y prometemos que no seremos demasiado pesados.',
    contact: {
        success: {
            title: 'Tu formulario se ha enviado correctamente',
            message: 'Pronto nos pondremos en contacto contigo.',
        },
    },
};
